import React, { useEffect, useState } from "react";

import axios from "axios";
import toast from "react-hot-toast";

import Layout from "../../utils/Layout";
import CustomDropdown from "../ReUseable/Dropdown/CustomDropdown";
import RecentExecutions from "./RecentExecutions";
import MappingChanges from "./MappingChanges";
import TaskStatus from "./TaskStatus";
import TodaysTask from "./TodaysTask";
import { API } from "../../global";

const Dashboard = () => {
  const [selectedPipeline, setSelectedPipeline] = useState("All Pipelines");
  const [selectedFrequency, setSelectedFrequency] = useState("This Month");
  const [pipelines, setPipelines] = useState([]);
  const [pipelineLogs, setPipelineLogs] = useState([]);
  const [totalPipelinesCount, setTotalPipelinesCount] = useState(0);
  const [rowCount, setRowCount] = useState(0);

  const pipelineFilters = [
    "Last 1 Hour",
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "Last 90 Days",
    "This Month",
    "Lifetime",
    "Custom"
  ];

  const handlePipelineChange = (option) => {
    setSelectedPipeline(option);
  }

  const handleFrequencyChange = (option) => {
    setSelectedFrequency(option);
  }

  useEffect(() => {
    getAllPipelines();
    getRowCount();
  }, [])

  useEffect(() => {
    getPipelineLogsData();
    // eslint-disable-next-line
  }, [selectedPipeline, selectedFrequency]);

  const getPipelineLogsData = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };

      const params = new URLSearchParams();
      if (selectedPipeline) params.append("pipeline", selectedPipeline);
      if (selectedFrequency) params.append("frequency", selectedFrequency);

      const response = await axios.get(
        `${API}/dashboard/filter-pipelines?${params.toString()}`,
        config
      );

      if (response.data.success) {
        setPipelineLogs(response.data.result);
      } else {
        toast.error(response.data.error.msg);
      }
    } catch (error) {
      toast.error("Error fetching pipeline log details");
    }
  }

  const getAllPipelines = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const response = await axios.get(`${API}/dashboard/all-pipelines`, config);
      if (response.data.success) {
        const pipelineNames = response.data.result.map(pipeline => pipeline.name);
        setPipelines(["All Pipelines", ...pipelineNames]);
        setTotalPipelinesCount(pipelineNames.length);
      } else {
        toast.error(response.data.error.msg);
      }
    } catch (error) {
      toast.error("Error fetching pipelines");
    }
  }

  const getRowCount = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const response = await axios.get(`${API}/dashboard/get-rows`, config);
      if (response.data.success) {
        setRowCount(response.data.result.totalRows);
      } else {
        toast.error(response.data.error.msg);
      }
    } catch (error) {
      toast.error("Error fetching Row count");
    }
  }

  return (
    <>
      <Layout>
        <div className="pt-12 ms-[50px] bg-[#F7F7F7] h-[100%] flex flex-col relative">
          <div className="flex justify-between items-center px-5 py-4 bg-white">
            <div className="text-xl text-black font-medium">Dashboard</div>
            <div className="flex gap-4 text-sm">
              <CustomDropdown
                options={pipelines}
                selected={selectedPipeline}
                onSelect={handlePipelineChange}
                width="w-60"
              />
              <CustomDropdown
                options={pipelineFilters}
                selected={selectedFrequency}
                onSelect={handleFrequencyChange}
                width="w-40"
              />
            </div>
          </div>

          {/* Cards Section */}
          <div className="grid grid-cols-4 gap-4 p-5 text-[#212529] font-medium">
            <div className="bg-white rounded-md shadow-md flex flex-col items-center gap-2">
              <h2 className="text-base pt-2 px-6">Total no of Sources</h2>
              <hr className="w-full border-t border-[#D4F1FF]" />
              <p className="text-4xl font-bold text-[#0083BF] px-6">{totalPipelinesCount}</p>
              <span className="text-sm px-6 pb-2">Sources</span>
            </div>

            <div className="bg-white rounded-md shadow-md flex flex-col items-center gap-2">
              <h2 className="text-base pt-2 px-6">Total no of Entities Mapped</h2>
              <hr className="w-full border-t border-[#D4F1FF]" />
              <p className="text-4xl font-bold text-[#0083BF] px-6">2048</p>
              <span className="text-sm px-6">Tables</span>
            </div>
            <div className="bg-white rounded-md shadow-md flex flex-col items-center gap-2">
              <h2 className="text-base pt-2 px-6">Quality of Source Data</h2>
              <hr className="w-full border-t border-[#D4F1FF]" />
              <p className="text-4xl font-bold text-[#0083BF] px-6">85%</p>
              <span className="text-sm pb-2 px-6">Good Data</span>
            </div>
            <div className="bg-white rounded-md shadow-md flex flex-col items-center gap-2">
              <h2 className="text-base pt-2 px-6">Quantity of Data</h2>
              <hr className="w-full border-t border-[#D4F1FF]" />
              <p className="text-4xl font-bold text-[#0083BF] px-6">{rowCount}</p>
              <span className="text-sm px-6 pb-2">Rows</span>
            </div>
          </div>

          <div className="m-4 flex gap-4">
            <div className="flex-auto w-32 rounded-md bg-white">
              <RecentExecutions
                selectedPipeline={selectedPipeline}
                pipelinesWithLogs={pipelineLogs}
              />
            </div>
            <div className="flex-auto w-32 bg-white">
              <MappingChanges />
            </div>
          </div>
          <div className="m-4 flex gap-4">
            <div className="flex-auto w-[75%] rounded-md bg-white">
              <TaskStatus
                pipelinesWithLogs={pipelineLogs}
              />
            </div>
            <div className="flex-auto w-[25%] bg-white">
              <TodaysTask />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Dashboard;